import { render, staticRenderFns } from "./LOVViewComponent.vue?vue&type=template&id=3b6285c4"
import script from "./LOVViewComponent.vue?vue&type=script&lang=js"
export * from "./LOVViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports